<template>
  <q-select
    v-model="selectItem"
    :options="props.options"
    outlined
    dense
    clearable
    emit-value
    map-options
    :error="props.error"
    hide-bottom-space
    style="background: var(--q-white); max-width: 580px"
    :rules="[(val) => (props.number === 1 ? isEmpty(val) || $t('validation.required') : true)]"
  >
    <template #default>
      <div v-if="!selectItem" style="position: absolute; top: 5px">
        <span class="text-dark">選択してください</span>
      </div>
    </template>
  </q-select>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isEmpty } from '../../common/utils/validateUtils';

interface FormatItemSelect {
  label: string;
  value: string;
}

interface Props {
  number: number;
  value: string;
  error?: boolean;
  options: FormatItemSelect[];
}

const props = withDefaults(defineProps<Props>(), {
  error: false,
});

const emit = defineEmits(['selectItem']);

// プルダウン選択値
const selectItem = computed({
  get: () => props.value,
  set: (value) => {
    emit('selectItem', value || '');
  },
});
</script>
